"use client";

import { c as _c } from "react/compiler-runtime";
import useWavesList from "@/hooks/useWavesList";
import useEnhancedWavesListCore from "./useEnhancedWavesListCore";
export type { MinimalWave } from "./useEnhancedWavesListCore";
function useEnhancedWavesList(activeWaveId) {
  const $ = _c(1);
  const wavesData = useWavesList();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      supportsPinning: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useEnhancedWavesListCore(activeWaveId, wavesData, t0);
}
export default useEnhancedWavesList;